@if (coreService.configurationLoaded() && crosscuttingService.user()) {
<div class="layout" [ngClass]="{ 'has-menu': showMenu() }">
	@if (showMenu()) {
	<div class="layout__menu" [ngClass]="{ opened: !menuService.mainMenuClosed() }">
		<unir-ai-main-menu (closeMenu)="closeMainMenu()"></unir-ai-main-menu>
	</div>
	}
	<div class="layout__main">
		<router-outlet class="content"></router-outlet>
	</div>
</div>
}

<p-toast class="toast-message" key="message-toast">
	<ng-template let-message pTemplate="message">
		<div class="toast-message__wrapper flex flex-column align-items-start">
			<div class="flex align-items-center gap-2">
				<span class="p-toast-summary">{{ message.summary }}</span>
			</div>
			<div class="p-toast-detail" [innerHTML]="message.detail"></div>
		</div>
	</ng-template>
</p-toast>
